import { LazyLoad } from '@petconsole/pure-fe-mui';

const BusAdmin = LazyLoad(() => import('./BusAdmin'));

export { BusAdmin };
